import { QuestionTypeEnum } from '@/models/Question';

export default function toQuestionKey(type: QuestionTypeEnum, id: number) {
  return `${type}:${id}`;
}
